<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-05-25 10:08:29
 * @LastEditors: dee
 * @LastEditTime: 2022-10-19 11:25:02
-->
<template>
  <div :class="['model', type, theme]" :style="model">
    <div :class="['modelTitle', type]" :style="{ backgroundColor: bColor, color: textColor }">{{ title }}</div>
    <div class="modelBg">
      <div class="list">
        <div :class="['item', { spacing: item.spacing, borderTop: item.top, borderBottom: item.bottom, borderAll: item.top && item.bottom, video: item.addType == 'video' }]" v-show="item.img || item.video" v-for="(item, index) in data" :key="index" @click="toUrl(item)">
          <template v-if="item.addType == 'video'">
            <div class="video-box" v-if="item.videoWidth > item.videoHeight">
              <!-- <img class="itemImg" :src="item.img" /> -->
              <video class="itemVideo" ref="video1" preload controls playsinline webkit-playsinline x5-video-player-fullscreen x5-video-player-type="h5" :src="item.video" :poster="item.img" >
              </video>
            </div>
            <div v-else>
              <div class="video-box2" @click="playVideo(index + 1)">
                <img class="itemImg" :src="item.img" />
                <i class="play-icon"></i>
              </div>
              <div class="full-video-box" v-show="isPlay">
                <video class="itemVideo" :ref="`video${index + 1}`" preload controls playsinline webkit-playsinline x5-video-player-fullscreen x5-video-player-type="h5" :src="item.video">
                </video>
                <img class="close" @click="clickClose(index + 1)" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
              </div>
            </div>
          </template>
          <template v-else>
            <img class="itemImg" :src="item.img" />
            <div class="go-btn" v-if="item.linkType == 2 && item.linkUrl && item.linkOriginalId">
              <wx-open-launch-weapp :username="item.linkOriginalId" :path="item.linkUrl" @error="handleErrorFn" @launch="handleLaunchFn">
                <script type="text/wxtag-template">
                  <style>
                    .btn{
                      width: 750px;
                      height: 9999px;
                    }
                  </style>
                  <div class="btn"></div>
                </script>
              </wx-open-launch-weapp>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils/common";
import wx from "weixin-js-sdk";

export default {
  props: ["data", "bColor", "title", "textColor", "type", "theme"],
  data() {
    return {
      iswx: false,
      isMiniApp: false,
      name: "1",
      info: "",
      longitude: "121.31296",
      latitude: "31.19402",
      telephoneNumber: "1",
      img: "https://assets-cos-test.yqaitech.com/marcloud/wx01f0b018d4951434/20211208964746591446.png",
      linkSwitch: 0,
      linkType: 1,
      linkUrl: "",
      linkOriginalId: "",
      isPlay: false,
    };
  },
  watch: {
    data: {
      handler(val) {
        const leng = val.length;
        val.map((item, index) => {
          let top = false;
          let bottom = false;
          top = index > 0 ? item.spacing : true;
          bottom = index + 1 < leng ? val[index + 1].spacing : true;
          console.log(top, bottom);
          item.top = top;
          item.bottom = bottom;
        });
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.iswx = util.browser.versions.wx;
    let _this = this;
    console.log(wx);
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
        _this.isMiniApp = true;
      } else {
        _this.isMiniApp = false;
      }
    });
  },
  computed: {
    model() {
      const { bColor } = this;
      const sty = {
        assistance: { backgroundColor: bColor },
        lightup: { backgroundColor: `${util.rgbToRgba(this.bColor, 0.3)}` },
      };
      if (this.theme == "theme2") {
        return {
          backgroundColor: this.$util.rgbToRgba(this.bColor, 0.5) ,
        };
      }
      return sty[this.type];
    },
  },
  methods: {
    handleErrorFn(e) {
      console.log("fail", e.detail);
    },
    handleLaunchFn(e) {
      console.log("success", e);
    },
    toUrl(item) {
      if (item.linkSwitch == 0) return;
      if (item.linkType == 1) {
        if (item.linkUrl.indexOf("http://") < 0 && item.linkUrl.indexOf("https://") < 0) window.location.href = "https://" + item.linkUrl;
        else {
          window.location.href = item.linkUrl;
        }
      }
      // if (!item.navLink) return;
      // if (
      //   item.navLink.indexOf("http://") < 0 &&
      //   item.navLink.indexOf("https://") < 0
      // )
      //   window.location.href = "https://" + item.navLink;
      // else {
      //   window.location.href = item.navLink;
      // }
    },
    nav(item, type) {
      if (type == "tel") {
        window.location.href = `tel:${item.telephoneNumber}`;
      }
      if (type == "nav") {
        window.location.href = `https://uri.amap.com/marker?position=${item.longitude},${item.latitude}&name=${item.address}&src=mypage&coordinate=gaode&callnative=0`;
      }
    },
    goAppUrl(link) {
      if (!link) {
        return false;
      }
      wx.miniProgram.navigateTo({
        url: `/${link}`,
        fail: function () {
          wx.miniProgram.switchTab({ url: `/${link}` });
        },
      });
    },
    playVideo(i) {
      this.isPlay = true
      // console.log(this.$refs['video' + i])
      this.$refs['video' + i][0].play();
      // this.$refs['video' + i][0].requestFullScreen()
    },
    clickClose(i) {
      this.isPlay = false
      this.$refs['video' + i][0].pause()
    },
  },
};
</script>
<style lang="stylus" scoped>
div {
  box-sizing: border-box;
}

.model {
  width: 351px;
  margin: 50px auto 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 12px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  // border: 5px solid;
  padding:5px;
  box-sizing: border-box;
  &.lightup{
    padding:10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
  }
  &.theme2 {
    padding: 10px;
    border: none;
    margin: 25px auto 0;
    box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
    background:  rgba(255, 255, 255, 0.1);
    .modelTitle {
      margin-top: -10px;
      box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 12px 12px;
    }
  }
  .modelTitle {
    position: absolute;
    margin-top: -20px;
    color: white;
    padding: 0 20px;
    line-height: 40px;
    height: 40px;
    text-align: center;
    border-radius: 6px;
    display: inline-block;
    font-size: 20px;
    font-weight: 600;
    z-index:1;
    &.lightup{
      margin-top: -10px;
      border-radius: 0px 0px 12px 12px;
    }
  }

  .modelBg {
    width: 100%;
    // background-color: rgba(255, 255, 255, 0.9);
    border-radius: 7px;

    .list {
      width: 100%;
      border-radius: 7px;
      .item {
        position relative;
        overflow:hidden;
        &.spacing{
          margin-top:10px;
        }
        &.borderTop{
          border-radius: 7px 7px 0 0;
        }
        &.borderBottom{
          border-radius:  0 0 7px 7px;
        }
        &.borderAll{
          border-radius:7px;
        }
        &.video {
          .play-icon {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 96px;
            height: 96px;
            background: url('https://assets.rurushishi.com/activies/activityCenter/play-icon.png') 0 0 / 100% no-repeat;
          }
        }
        .video-box {
          position: relative;
          // &::after {
          //   position: absolute;
          //   top: 50%;
          //   left: 50%;
          //   transform: translate(-50%, -50%);
          //   width: 96px;
          //   height: 96px;
          //   background: url('https://assets.rurushishi.com/activies/activityCenter/play-icon.png') 0 0 / 100% no-repeat;
          //   z-index 10000;
          // }
          // .itemVideo {
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   width: 100%;
          //   height: 100%;
          // }
        }
        .video-box2 {
          
        }
        .full-video-box {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0,0, 0.4);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          .close {
            position: absolute;
            top: 20px;
            right: 20px;
            width: 40px;
            height: 40px;
            // z-index: 1002;
          }
        }
        .itemVideo {
          width: 100%;
        }
        .itemImg{
          width:100%;
        }
        .go-btn {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
